import i18next from "i18next";
import translationResources from "./engine";
import volvoResources from "./engine/volvo";
import detector from "i18next-browser-languagedetector";

const i18n = i18next.createInstance();
const FALLBACK_NAMESPACE = "translation";

const BRAND_RESOURCES = {
    volvo: volvoResources,
};

const toNamespace = brand => brand.toLowerCase().replace(/[^a-z0-9]/g, "");

const BRAND_NAMESPACES = Object.keys(BRAND_RESOURCES).map(brand => toNamespace(brand));
const namespaces = [...BRAND_NAMESPACES, FALLBACK_NAMESPACE];

export type translate = string => string;

export const getNamespaceForBrand = (brand: string) => {
	if (!brand) {
		return FALLBACK_NAMESPACE;
	}

	return toNamespace(brand);
};

const ensureNamespace = namespace => {
	Object.keys(translationResources).forEach(language => {
		if (!i18n.hasResourceBundle(language, namespace)) {
			i18n.addResourceBundle(language, namespace, {});
		}
	});
};

export const setDefaultNamespaceForBrand = (brand: string) => {
	const namespace = getNamespaceForBrand(brand);
	if (i18n.options.defaultNS === namespace) {
		return;
	}

	ensureNamespace(namespace);
	i18n.setDefaultNamespace(namespace);
};

i18n
    .use(detector)
	.init({
		debug: process.env.NODE_ENV !== "production",
		fallbackLng: "en",
		ns: namespaces,
		defaultNS: FALLBACK_NAMESPACE,
		fallbackNS: FALLBACK_NAMESPACE,
        load: "languageOnly",  // optional
        resources: {}
	});

Object.keys(translationResources)
.forEach(language => {
    BRAND_NAMESPACES.forEach(brand => {
        i18n.addResourceBundle(language, brand, BRAND_RESOURCES[brand][language] || {});
    })
	i18n.addResourceBundle(language, FALLBACK_NAMESPACE, translationResources[language]);
});

export default i18n;
